export const singleStructures = ['1', '2', '7'];
